import {ChartIQPeriodicity} from "../../types/ChartIQ";

export interface ChartPeriod {
    translation: string;
    shortDisplay: string;
    data: ChartIQPeriodicity;
}

export const ONE_MINUTE: ChartPeriod = {
    translation: "chart.ONE_MINUTE",
    shortDisplay: "chart.ONE_MINUTE_SHORT",
    data: {
        period: 1,
        interval: 1,
        timeUnit: "minute"
    }
};

export const THREE_MINUTES: ChartPeriod = {
    translation: "chart.THREE_MINUTES",
    shortDisplay: "chart.THREE_MINUTES_SHORT",
    data: {
        period: 1,
        interval: 3,
        timeUnit: "minute"
    }
};

export const FIVE_MINUTES: ChartPeriod = {
    translation: "chart.FIVE_MINUTES",
    shortDisplay: "chart.FIVE_MINUTES_SHORT",
    data: {
        period: 1,
        interval: 5,
        timeUnit: "minute"
    }
};

export const TEN_MINUTES: ChartPeriod = {
    translation: "chart.TEN_MINUTES",
    shortDisplay: "chart.TEN_MINUTES_SHORT",
    data: {
        period: 1,
        interval: 10,
        timeUnit: "minute"
    }
};

export const FIFTEEN_MINUTES: ChartPeriod = {
    translation: "chart.FIFTEEN_MINUTES",
    shortDisplay: "chart.FIFTEEN_MINUTES_SHORT",
    data: {
        period: 1,
        interval: 15,
        timeUnit: "minute"
    }
};

export const THIRTY_MINUTES: ChartPeriod = {
    translation: "chart.THIRTY_MINUTES",
    shortDisplay: "chart.THIRTY_MINUTES_SHORT",
    data: {
        period: 1,
        interval: 30,
        timeUnit: "minute"
    }
};

export const FORTYFIVE_MINUTES: ChartPeriod = {
    translation: "chart.FORTY_FIVE_MINUTES",
    shortDisplay: "chart.FORTY_FIVE_MINUTES_SHORT",
    data: {
        period: 3,
        interval: 15,
        timeUnit: "minute"
    }
};

export const ONE_HOUR: ChartPeriod = {
    translation: "chart.ONE_HOUR",
    shortDisplay: "chart.ONE_HOUR_SHORT",
    data: {
        period: 1,
        interval: 60,
        timeUnit: "minute"
    }
};

export const TWO_HOURS: ChartPeriod = {
    translation: "chart.TWO_HOURS",
    shortDisplay: "chart.TWO_HOURS_SHORT",
    data: {
        period: 2,
        interval: 60,
        timeUnit: "minute"
    }
};

export const THREE_HOURS: ChartPeriod = {
    translation: "chart.THREE_HOURS",
    shortDisplay: "chart.THREE_HOURS_SHORT",
    data: {
        period: 3,
        interval: 60,
        timeUnit: "minute"
    }
};

export const FOUR_HOURS: ChartPeriod = {
    translation: "chart.FOUR_HOURS",
    shortDisplay: "chart.FOUR_HOURS_SHORT",
    data: {
        period: 4,
        interval: 60,
        timeUnit: "minute"
    }
};

export const ONE_DAY: ChartPeriod = {
    translation: "chart.ONE_DAY",
    shortDisplay: "chart.ONE_DAY_SHORT",
    data: {
        period: 1,
        interval: "day",
        timeUnit: null
    }
};

export const ONE_WEEK: ChartPeriod = {
    translation: "chart.ONE_WEEK",
    shortDisplay: "chart.ONE_WEEK_SHORT",
    data: {
        period: 1,
        interval: "week",
        timeUnit: null
    }
};

export const ONE_MONTH: ChartPeriod = {
    translation: "chart.ONE_MONTH",
    shortDisplay: "chart.ONE_MONTH_SHORT",
    data: {
        period: 1,
        interval: "month",
        timeUnit: null
    }
};

export const IntraDayPeriods = [
    ONE_MINUTE,
    THREE_MINUTES,
    FIVE_MINUTES,
    TEN_MINUTES,
    FIFTEEN_MINUTES,
    THIRTY_MINUTES,
    FORTYFIVE_MINUTES,
    ONE_HOUR,
    TWO_HOURS,
    THREE_HOURS,
    FOUR_HOURS,
];

export const InterDayPeriods = [
    ONE_DAY,
    ONE_WEEK,
    ONE_MONTH
];

export const Periods = [
    ONE_MINUTE,
    THREE_MINUTES,
    FIVE_MINUTES,
    TEN_MINUTES,
    FIFTEEN_MINUTES,
    THIRTY_MINUTES,
    FORTYFIVE_MINUTES,
    ONE_HOUR,
    TWO_HOURS,
    THREE_HOURS,
    FOUR_HOURS,
    ONE_DAY,
    ONE_WEEK,
    ONE_MONTH
];

export function periodsMatch(p1: ChartIQPeriodicity, p2: ChartIQPeriodicity): boolean {
    return p1.period === p2.period && p1.interval === p2.interval && p1.timeUnit === p2.timeUnit;
}
